import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {},
  label: {},
  fields: {
    padding: theme.spacing(0),
  },
  group: {
    marginBottom: theme.spacing(4),
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
});

const FacetPlanOutcomeQuickEditEmergencyFundLayout = ({
  className,
  classes,
}) => {
  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const { refreshPageContentCollection } = usePageContentContext();

  const {
    loadModalCollectionByLink,
    clearModalCollection,
  } = useModalContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box className={classNames(classes.root, className)}>
      <TitleSection />
      {resource.attr('educationType') === 'custom' && (
      <Alert
        severity={'warning'}
        className={classes.alert}
      >
        <Typography>Please update custom years and costs in the Education outcome advanced editing modal</Typography>
      </Alert>
      )}
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={async () => {
          const resp = await onSubmit();
          if (resp) {
            clearModalCollection();
            refreshPageContentCollection();
          }
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanOutcomeQuickEditEmergencyFundLayout.defaultProps = {
  className: '',
};

FacetPlanOutcomeQuickEditEmergencyFundLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanOutcomeQuickEditEmergencyFundLayout);
